import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { withLocalize } from 'react-localize-redux';
import { domainActions } from '../../../store/domainStore';
import Widget from '../../common/widget';
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";

const DOMAIN = "relation-group-dictionary";

class RelationSection extends React.Component {
    render() {
        return (
            <Widget className="create-portfolio-widget" header="Monitoring.Create.Relations" initialExpanded={true}>
                <div className="columns">
                    <div className="column">
                        <PopupMultiSelectButton
                            horizontal
                            data={DOMAIN}
                            name={DOMAIN}
                            placeholder={this.props.translate("Monitoring.Create.RelationsType")}
                            onClick={() => this.props.forceDomainDataFiltered(DOMAIN, { marketAttribute: this.marketAttr() })}
                            selection={this.props.formik.values.relationTypes}
                            title={this.props.translate('Monitoring.Create.RelationsType')}
                            handleChange={(all, parent) => {
                                this.props.formik.setFieldValue('relationTypes', { all: all, parent: parent });
                                this.checkIfAll(DOMAIN, "relationTypes", all.length)
                            }}
                        />
                    </div>
                </div>
            </Widget>
        )}

    componentDidMount() {
        this.props.forceDomainDataFiltered(DOMAIN, { marketAttribute: this.marketAttr()});
    }

    marketAttr() {
        return this.props.formik.values.identification.marketingCountry === "SK" ? 2 : 1;
    }

    checkIfAll = (domain, field, length) => {
        if (this.props.hasOwnProperty(domain) && this.props[domain].requestResult !== null && this.props[domain].requestResult.length === length) {
            this.props.formik.setFieldValue(`${field}.allSelected`, true);
            return true;
        }
        this.props.formik.setFieldValue(`${field}.allSelected`, false);
        return false;
    }
}
export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(RelationSection)));